export default __webpack_public_path__ + "static/media/Smart-Biology-CELLS-U1-Cover-Image.db91b63a.jpg";